import bidderHome from '@/views/bidder/bidderHome/index.vue'
import registration from '@/views/bidder/registration/index.vue'
import registrationStatus from '@/views/bidder/registrationStatus/index.vue'
import uploadBid from '@/views/bidder/uploadBid/index.vue'
import inviteBidding from '@/views/bidder/inviteBidding/index.vue'
import inviteBiddingPurchase from '@/views/bidder/inviteBiddingPurchase/index.vue'
import myOrders from '@/views/bidder/myOrders/index.vue'
import myPurchaseProjects from '@/views/bidder/myPurchaseProjects/index.vue'
import supplementProcurement from '@/views/bidder/supplementProcurement/index.vue'
import organizationModify from '@/views/bidder/organizationModify/index.vue'
import professionalPersonnel from '@/views/bidder/professionalPersonnel/index.vue'
import changePassword from '@/views/bidder/changePassword/index.vue'
import userInfoModify from '@/views/bidder/userInfoModify/index.vue'
import creditQuery from '@/views/bidder/creditQuery/index.vue'
import caManagement from '@/views/bidder/caManagement/index.vue'
import todoList from '@/views/bidder/todoList/index.vue'
import bidderFlow from '@/views/bidder/bidderChild/bidderFlow.vue'
import checkNotice from '@/views/bidder/bidderChild/checkNotice.vue'
import makeBidDocument from '@/views/bidder/bidderChild/makeBidDocument.vue'
import downloadTender from '@/views/bidder/bidderChild/downloadTender.vue'
import bidClarification from '@/views/bidder/bidderChild/bidClarification.vue'
import technologyFee from '@/views/bidder/bidderChild/technologyFee.vue'
import bidDocument from '@/views/bidder/bidderChild/bidDocument.vue'
import confirmBidRecord from '@/views/bidder/bidderChild/confirmBidRecord.vue'
import answerJudges from '@/views/bidder/bidderChild/answerJudges.vue'
import bidSecondQuotate from '@/views/bidder/bidderChild/bidSecondQuotate.vue'
import viewWinBids from '@/views/bidder/bidderChild/viewWinBids.vue'
import raiseAQuestion from '@/views/bidder/bidderChild/raiseAQuestion.vue'
import bidNoticeSuccessful from '@/views/bidder/bidderChild/bidNoticeSuccessful.vue'
import objectionManagement from '@/views/bidder/bidderChild/objectionManagement.vue'
import bidDocumentDetail from '@/views/bidder/bidderChild/bidDocumentDetail.vue'
import bidderProjectWorkflow from '@/views/bidder/semiProcessChild/bidderProjectWorkflow.vue'
import winBulletinList from '@/views/bidder/semiProcessChild/winBulletinList.vue'
import winBulletinDetail from '@/views/bidder/semiProcessChild/winBulletinDetail.vue'
import winCandidateList from '@/views/bidder/semiProcessChild/winCandidateList.vue'
import winCandidateListDetail from '@/views/bidder/semiProcessChild/winCandidateListDetail.vue'
import bidAnnouncementPublish from '@/views/bidder/semiProcessChild/bidAnnouncementPublish.vue'
import bidAnnouncementPublishDetail from '@/views/bidder/semiProcessChild/bidAnnouncementPublishDetail.vue'
export default [
  {
    path: '/bidderHome',
    component: bidderHome,
    redirect: '/bidderHome/todoList',
    children: [
      { path: 'registration', name: 'registration', component: registration },
      { path: 'registrationStatus', name: 'registrationStatus', component: registrationStatus },
      { path: 'uploadBid', name: 'uploadBid', component: uploadBid },
      { path: 'inviteBidding', name: 'inviteBidding', component: inviteBidding },
      { path: 'inviteBiddingPurchase', name: 'inviteBiddingPurchase', component: inviteBiddingPurchase },
      { path: 'myOrders', name: 'myOrders', component: myOrders },
      { path: 'myPurchaseProjects', name: 'myPurchaseProjects', component: myPurchaseProjects },
      { path: 'bidderFlow', name: 'bidderFlowBidder', component: bidderFlow },
      { path: 'bidderProjectWorkflow', name: 'bidderProjectWorkflow', component: bidderProjectWorkflow },
      { path: 'bidAnnouncementPublish', name: 'bidAnnouncementPublish', component: bidAnnouncementPublish },
      { path: 'bidAnnouncementPublishDetail', name: 'bidAnnouncementPublishDetail', component: bidAnnouncementPublishDetail },
      { path: 'winBulletinList', name: 'winBulletinList', component: winBulletinList },
      { path: 'winBulletinDetail', name: 'winBulletinDetail', component: winBulletinDetail },
      { path: 'winCandidateList', name: 'winCandidateList', component: winCandidateList },
      { path: 'winCandidateListDetail', name: 'winCandidateListDetail', component: winCandidateListDetail },
      { path: 'checkNotice', name: 'checkNotice', component: checkNotice },
      { path: 'supplementProcurement', name: 'supplementProcurement', component: supplementProcurement },
      { path: 'organizationModify', name: 'organizationModify', component: organizationModify },
      { path: 'professionalPersonnel', name: 'professionalPersonnel', component: professionalPersonnel },
      { path: 'changePassword', name: 'changePassword', component: changePassword },
      { path: 'userInfoModify', name: 'userInfoModify', component: userInfoModify },
      { path: 'creditQuery', name: 'creditQuery', component: creditQuery },
      { path: 'caManagement', name: 'caManagement', component: caManagement },
      { path: 'todoList', name: 'todoList', component: todoList },
      // 二级页面
      { path: 'makeBidDocument', name: 'makeBidDocument', component: makeBidDocument },
      { path: 'downloadTender', name: 'downloadTender', component: downloadTender },
      { path: 'bidClarification', name: 'bidClarification', component: bidClarification },
      { path: 'technologyFee', name: 'technologyFee', component: technologyFee },
      { path: 'bidDocument', name: 'bidDocument', component: bidDocument },
      { path: 'confirmBidRecord', name: 'confirmBidRecord', component: confirmBidRecord },
      { path: 'answerJudges', name: 'answerJudges', component: answerJudges },
      { path: 'bidSecondQuotate', name: 'bidSecondQuotate', component: bidSecondQuotate },
      { path: 'viewWinBids', name: 'viewWinBids', component: viewWinBids },
      { path: 'raiseAQuestion', name: 'raiseAQuestion', component: raiseAQuestion },
      { path: 'bidNoticeSuccessful', name: 'bidNoticeSuccessful', component: bidNoticeSuccessful },
      { path: 'objectionManagement', name: 'objectionManagement', component: objectionManagement },
      { path: 'bidDocumentDetail', name: 'bidDocumentDetail', component: bidDocumentDetail },
    ]
  },
]
